import { Instrument as InstrumentBase } from '../../bases/instrument';
import * as CONSTANTS from './constants';
import { getConfigurationValue } from '../../state/init';
import { Aggregator } from './aggregator';

export class Instrument extends InstrumentBase {
  static featureName = CONSTANTS.SIGNAL_NAME;

  constructor() {
    const aggregator = new Aggregator();

    super(aggregator, Instrument.featureName);

    this.config = getConfigurationValue(
      `instruments.signals.${Instrument.featureName}`,
    );

    if (!this.hasKey) {
      return;
    }

    if (this.auto) {
      this.start();
    }
  }

  start() {
    void import('./module').then(({ Module: Traces }) => {
      this.module = new Traces(
        this.aggregator,
        this.config,
        getConfigurationValue('otel'),
      );
      this.module.start();
    });
  }
}
